import { FileEntity, MainBackendSuccessResponse } from '@flicent/fieldpulse-react-component-library-frontend';

import { IMAGE_FILE_URLS_VERSIONS } from '@/constants';
import { createFileResponseToFileEntity } from '@/utils';

import { MainServerApiServiceInstance } from './MainServerApi.service';
import { CreateFileResponse } from '@/interfaces';


const sanitizeFileNameAndDescription = (name: any): string => {
  if (typeof name !== 'string') {
    return '';
  }

  return name
    // replace newlines with spaces to prevent error "Invalid header value"
    .replace(/[\r\n]/g, ' ')
    // remove all non iso-8859-1 characters to prevent error "string contains non iso-8859-1 code point"
    .replace(/[^\x00-\xFF]/g, '')
    .trim();
};

interface RequestParams {
  token: string;
  fileEntityUuid: string;
  fieldId: number;
  extension: string;
  displayName: string;
  notes: string;
  file: File;
}

interface ResponseDataType extends MainBackendSuccessResponse<CreateFileResponse> {
}

export const createCustomFormFieldsFilesRequest = ({
                                                     token,
                                                     fileEntityUuid,
                                                     fieldId,
                                                     extension,
                                                     displayName,
                                                     notes,
                                                     file,
                                                   }: RequestParams, onProgress?: (progressPercent: number) => void): Promise<FileEntity> => {

  return MainServerApiServiceInstance.makeRequest<ResponseDataType>(`/file`, {
    method: 'POST',
    token,
    headers: {
      'Parent-Type': 'customformfield',
      'Parent-Id': fieldId.toString(),
      'File-Extension': extension,
      'Display-Name': sanitizeFileNameAndDescription(displayName),
      'Notes': sanitizeFileNameAndDescription(notes),
      'Image-File-Urls-Versions': IMAGE_FILE_URLS_VERSIONS,
    },
    body: file,
    onProgress,
  }).then(({ response }) => createFileResponseToFileEntity(fileEntityUuid, response));
};